import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { ApplicationList } from 'types/api'
import { BaseResponse } from 'types/utils'

export const regionsQueryKey = ['applications']

export function useApplicationTable() {
  const [searchParams] = useSearchParams()
  const searchValue = searchParams.get('search') || undefined
  const ordering = searchParams.get('ordering') || undefined
  const limit = searchParams.get('limit') || undefined
  const offset = searchParams.get('offset') || undefined
  const status = searchParams.get('status') || undefined
  const arrivalDateFrom = searchParams.get('arrival_date_from') || undefined
  const arrivalDateTo = searchParams.get('arrival_date_to') || undefined
  const rentMinGte = searchParams.get('rent_min_gte') || undefined
  const rentMaxLte = searchParams.get('rent_max_lte') || undefined
  const location = searchParams.get('location') || undefined

  async function getApplications() {
    const response = await apiClient.get<BaseResponse<ApplicationList>>(
      SNA_PREFIX + 'applications',
      {
        params: {
          search: searchValue,
          ordering: ordering,
          limit: limit,
          offset: offset,
          status: status,
          arrival_date_from: arrivalDateFrom,
          arrival_date_to: arrivalDateTo,
          rent_min_gte: rentMinGte,
          rent_max_lte: rentMaxLte,
          location: location
        }
      }
    )
    return response.data
  }

  return useQuery({
    queryFn: getApplications,
    queryKey: [
      ...regionsQueryKey,
      searchValue,
      ordering,
      limit,
      offset,
      status,
      arrivalDateFrom,
      arrivalDateTo,
      rentMinGte,
      rentMaxLte,
      location
    ]
  })
}
